module.exports = __webpack_public_path__ + "fonts/d42dad2.woff";